export const CHART_IDS = {
  ALLUVIAL_DIAGRAM: 'rawgraphs.alluvialdiagram',
  ARC_DIAGRAM: 'rawgraphs.arcdiagram',
  BAR_CHART: 'rawgraphs.barchart',
  BAR_CHART_MULTISET: 'rawgraphs.barchartmultiset',
  BAR_CHART_STACKED: 'rawgraphs.barchartstacked',
  BEESWARM: 'rawgraphs.beeswarm',
  BOX_PLOT: 'rawgraphs.boxplot',
  BUBBLE_CHART: 'rawgraphs.bubblechart',
  BUMP_CHART: 'rawgraphs.bumpchart',
  CHORD_DIAGRAM: 'rawgraphs.chorddiagram',
  CIRCLE_PACKING: 'rawgraphs.circlepacking',
  CIRCULAR_DENDROGRAM: 'rawgraphs.circulardendrogram',
  CONTOUR_PLOT: 'rawgraphs.contourplot',
  CONVEX_HULL: 'rawgraphs.convexhull',
  HEXAGONAL_BINNING: 'rawgraphs.hexagonalbinning',
  HORIZON_GRAPH: 'rawgraphs.horizongraph',
  LINEAR_DENDROGRAM: 'rawgraphs.lineardendrogram',
  LINE_CHART: 'rawgraphs.linechart',
  MATRIX_PLOT: 'rawgraphs.matrixplot',
  PARALLEL_COORDINATES: 'rawgraphs.parallelcoordinates',
  PIE_CHART: 'rawgraphs.piechart',
  POINT_MAP: 'rawgraphs.pointmap',
  FORCE_DIRECTED_GRAPH: 'rawgraphs.forcedirectedgraph',
  RADAR_CHART: 'rawgraphs.radarchart',
  SANKEY_DIAGRAM: 'rawgraphs.sankeydiagram',
  SLOPE_CHART: 'rawgraphs.slopechart',
  STREAM_GRAPH: 'rawgraphs.streamgraph',
  SUNBURST: 'rawgraphs.sunburst',
  TREEMAP: 'rawgraphs.treemap',
  VIOLIN_PLOT: 'rawgraphs.violinplot',
  VORONOI_DIAGRAM: 'rawgraphs.voronoidiagram',
  VORONOI_TREEMAP: 'rawgraphs.voronoitreemap',
}
